module.exports = __webpack_public_path__ + "media/images/icons/twotone/profile-3e90777ec9359fa3a2c31a0945e6fb7e.svg";